import { styled } from '@classify/react-core-components/styles';
import Paper from '@mui/material/Paper';
import { MenuItem, MenuList } from '@openclassrooms/ui-web/navigation';
import Divider from '@classify/react-core-components/Divider';
import Typography from '@classify/react-core-components/Typography';

import { translate } from '@openclassrooms/translations';
import { ROUTES, getButtonLinkProps } from '@openclassrooms/routing';

const MenuItemStyled = styled(MenuItem)({ '& .MuiListItemText-inset': { paddingLeft: 0 } });
const SectionTitle = styled(Typography)(({ theme: { spacing, palette } }) => ({
  margin: spacing(1, 1, 1, 2),
  color: palette.text.secondary,
})) as typeof Typography;

export default function MainHeaderVisitorMenu() {
  return (
    <Paper elevation={8}>
      <MenuList id="main-header-menu">
        <MenuItemStyled
          {...getButtonLinkProps(ROUTES.AUTH.LOGIN)}
          label={translate('main_header.create_account')}
          data-event="Navigation|Redirection::Internal|Header account creation"
        />
        <MenuItemStyled
          {...getButtonLinkProps(ROUTES.AUTH.LOGIN)}
          label={translate('main_header.login')}
          data-event="Navigation|Redirection::Internal|Header login"
        />

        <Divider />

        <SectionTitle variant="overline">{translate('main_header.students')}</SectionTitle>
        <MenuItemStyled
          {...getButtonLinkProps(ROUTES.APPLICATION.INDEX)}
          label={translate('global.apply.cta')}
          data-event="Navigation|Redirection::Internal|Header apply"
        />

        <Divider />

        <SectionTitle variant="overline">{translate('main_header.employer')}</SectionTitle>
        <MenuItemStyled
          {...getButtonLinkProps(ROUTES.MY_ORGANIZATION.OVERVIEW)}
          label={translate('global.word.access_employer_space')}
          data-event="Navigation|Redirection::Internal|Header employer space"
        />
      </MenuList>
    </Paper>
  );
}
